/* Catalog sort menu.
   Featured mixes patterns so the same family is not shown twice in a row.
   A-Z, Z-A, and date reorder the cards already on the page.
   The menu does not refetch the collection section. */
(function () {
  function isOneOff(key) {
    return key.indexOf('one-') === 0;
  }

  function gridItems() {
    var grid = document.getElementById('product-grid');
    if (!grid) return [];
    return Array.prototype.filter.call(grid.children, function (el) {
      return el.classList && el.classList.contains('grid__item') && el.dataset.acPattern;
    });
  }

  function originalItems() {
    return gridItems().sort(function (a, b) {
      return Number(a.dataset.acSortIndex || 0) - Number(b.dataset.acSortIndex || 0);
    });
  }

  var FEATURED_LEAD = [
    'amalfi lemon',
    'black&pink checkerboard',
    'purple sunset',
    'trick or treat'
  ];

  function titleKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s*&\s*/g, '&')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function mixItems(nodes, startLast) {
    var groups = new Map();
    nodes.forEach(function (node, index) {
      var key = node.dataset.acPattern || 'one-' + index;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(node);
    });

    function keysWith(predicate) {
      var found = [];
      groups.forEach(function (list, key) {
        if (list.length && predicate(key)) found.push(key);
      });
      return found;
    }

    function fullest(keys) {
      keys.sort(function (a, b) {
        return groups.get(b).length - groups.get(a).length;
      });
      return keys[0];
    }

    var last = startLast || null;
    var ordered = [];
    var guard = nodes.length;
    while (guard--) {
      var shared = keysWith(function (key) {
        return !isOneOff(key) && key !== last;
      });
      var ones = keysWith(isOneOff);
      var key = null;
      if (!last || isOneOff(last)) {
        key = shared.length ? fullest(shared) : ones[0];
      } else if (ones.length) {
        key = ones[0];
      } else if (shared.length) {
        key = fullest(shared);
      }
      if (!key) key = keysWith(function () { return true; })[0];
      if (!key) break;
      ordered.push(groups.get(key).shift());
      last = key;
    }
    return ordered;
  }

  function featuredOrder(nodes) {
    var rest = nodes.slice();
    var lead = [];
    FEATURED_LEAD.forEach(function (wanted) {
      for (var i = 0; i < rest.length; i++) {
        if (titleKey(rest[i].dataset.acSortTitle) !== wanted) continue;
        lead.push(rest.splice(i, 1)[0]);
        break;
      }
    });
    var last = lead.length ? lead[lead.length - 1].dataset.acPattern || null : null;
    return lead.concat(mixItems(rest, last));
  }

  function compare(sort) {
    return function (a, b) {
      var titleA = a.dataset.acSortTitle || '';
      var titleB = b.dataset.acSortTitle || '';
      var createdA = a.dataset.acSortCreated || '';
      var createdB = b.dataset.acSortCreated || '';
      var indexA = Number(a.dataset.acSortIndex || 0);
      var indexB = Number(b.dataset.acSortIndex || 0);
      var titleOrder = titleA.localeCompare(titleB, undefined, { numeric: true, sensitivity: 'base' });
      if (sort === 'title-ascending') return titleOrder || indexA - indexB;
      if (sort === 'title-descending') return -titleOrder || indexA - indexB;
      if (sort === 'created-ascending') {
        if (createdA < createdB) return -1;
        if (createdA > createdB) return 1;
        return indexA - indexB;
      }
      if (sort === 'created-descending') {
        if (createdA > createdB) return -1;
        if (createdA < createdB) return 1;
        return indexA - indexB;
      }
      return indexA - indexB;
    };
  }

  function normalizeSort(sort) {
    if (!sort || sort === 'featured' || sort === 'manual' || sort === 'best-selling' || sort.indexOf('price-') === 0) {
      return 'featured';
    }
    if (sort === 'title-ascending' || sort === 'title-descending' || sort === 'created-ascending' || sort === 'created-descending') {
      return sort;
    }
    return 'featured';
  }

  function selectedSort() {
    var select = document.querySelector('select[name="sort_by"]');
    if (select && select.value) return normalizeSort(select.value);
    return normalizeSort(new URLSearchParams(window.location.search).get('sort_by') || '');
  }

  function revealGrid() {
    var grid = document.getElementById('product-grid');
    if (grid) grid.removeAttribute('data-ac-sort-pending');
  }

  var LEAD_IMAGES = 8;
  var imageSchedule = 0;
  var imageWatchers = [];

  function restoreImage(img) {
    if (img.dataset.acDeferred !== '1') return;
    if (img.dataset.acSrcset) img.setAttribute('srcset', img.dataset.acSrcset);
    if (img.dataset.acSrc) img.setAttribute('src', img.dataset.acSrc);
    var ready = img.complete && img.naturalWidth > 0;
    if (ready) img.style.transition = 'none';
    delete img.dataset.acDeferred;
    if (ready) {
      requestAnimationFrame(function () {
        img.style.transition = '';
      });
    }
  }

  function holdImage(img) {
    if (img.dataset.acDeferred === '1' || img.dataset.acLead === '1') return;
    var src = img.getAttribute('src') || '';
    if (img.complete && img.naturalWidth > 1 && src.indexOf('data:') !== 0) return;
    var srcset = img.getAttribute('srcset') || '';
    if (!src && !srcset) return;
    if (src.indexOf('data:') === 0) return;
    img.dataset.acSrc = src;
    img.dataset.acSrcset = srcset;
    img.removeAttribute('srcset');
    img.removeAttribute('src');
    img.loading = 'lazy';
    img.removeAttribute('fetchpriority');
    img.dataset.acDeferred = '1';
  }

  function cardMediaImages(item) {
    var imgs = item.querySelectorAll('.card__media img');
    if (imgs.length) return Array.prototype.slice.call(imgs);
    return Array.prototype.slice.call(item.querySelectorAll('img'));
  }

  function showImage(img, priority) {
    if (img.dataset.acLead === '1') {
      restoreImage(img);
      return;
    }
    restoreImage(img);
    if (priority === 'high') {
      img.loading = 'eager';
      img.setAttribute('fetchpriority', 'high');
      img.dataset.acLead = '1';
      return;
    }
    if (priority === 'soon') {
      img.loading = 'eager';
      img.setAttribute('fetchpriority', 'auto');
      return;
    }
    img.loading = 'lazy';
    img.setAttribute('fetchpriority', 'low');
  }

  function disconnectImageWatchers() {
    imageWatchers.forEach(function (observer) {
      observer.disconnect();
    });
    imageWatchers = [];
  }

  function warmCard(item) {
    cardMediaImages(item).forEach(function (img, index) {
      showImage(img, index === 0 ? 'soon' : 'low');
    });
  }

  // The first screen stays eager so the top of the catalog paints first.
  // Cards further down start about two screens before they scroll into view,
  // instead of waiting until the first batch finishes and then loading all at once.
  function scheduleCatalogImages() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var gen = ++imageSchedule;
    disconnectImageWatchers();
    var items = Array.prototype.filter.call(grid.children, function (node) {
      return node.nodeType === 1 && node.classList.contains('grid__item');
    });

    items.forEach(function (item, index) {
      var imgs = cardMediaImages(item);
      if (!imgs.length) return;
      if (index < LEAD_IMAGES) {
        showImage(imgs[0], 'high');
        imgs.slice(1).forEach(holdImage);
        return;
      }
      imgs.forEach(function (img) {
        delete img.dataset.acLead;
        holdImage(img);
      });
    });

    if (!grid.dataset.acImageWarm) {
      grid.dataset.acImageWarm = '1';
      grid.addEventListener('pointerover', function (event) {
        var item = event.target.closest && event.target.closest('.grid__item');
        if (!item || !grid.contains(item)) return;
        warmCard(item);
      });
    }

    if (typeof IntersectionObserver !== 'function') {
      items.forEach(warmCard);
      return;
    }

    var ahead = new IntersectionObserver(function (entries) {
      if (gen !== imageSchedule) return;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var imgs = cardMediaImages(entry.target);
        if (imgs[0]) showImage(imgs[0], 'soon');
        ahead.unobserve(entry.target);
      });
    }, { root: null, rootMargin: '60% 0px 220% 0px', threshold: 0 });

    var close = new IntersectionObserver(function (entries) {
      if (gen !== imageSchedule) return;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cardMediaImages(entry.target).slice(1).forEach(function (img) {
          showImage(img, 'low');
        });
        close.unobserve(entry.target);
      });
    }, { root: null, rootMargin: '15% 0px 40% 0px', threshold: 0 });

    imageWatchers.push(ahead, close);
    items.forEach(function (item) {
      if (!cardMediaImages(item).length) return;
      ahead.observe(item);
      close.observe(item);
    });
  }

  function applySort(sort) {
    var grid = document.getElementById('product-grid');
    var nodes = originalItems();
    if (!grid || nodes.length < 2) {
      revealGrid();
      return;
    }
    var ordered = sort === 'featured' ? featuredOrder(nodes) : nodes.slice().sort(compare(sort));
    var fragment = document.createDocumentFragment();
    ordered.forEach(function (node) {
      fragment.appendChild(node);
    });
    grid.appendChild(fragment);
    revealGrid();
    scheduleCatalogImages();
  }

  var applyingSort = false;
  var sortSeq = 0;

  function clearSortBusy(seq) {
    if (seq !== sortSeq) return;
    if (typeof window.acSetCatalogBusy === 'function') window.acSetCatalogBusy('sort', false);
  }

  function onSortInput(event) {
    var select = event.target;
    if (!select || select.name !== 'sort_by') return;
    event.stopImmediatePropagation();
    if (applyingSort) return;
    applyingSort = true;
    var seq = ++sortSeq;
    try {
      var sort = normalizeSort(select.value);
      document.querySelectorAll('select[name="sort_by"]').forEach(function (other) {
        if (other.value !== sort) other.value = sort;
      });
      if (typeof window.acSetCatalogBusy === 'function') window.acSetCatalogBusy('sort', true);
      applySort(sort);
      var url = new URL(window.location.href);
      if (sort === 'featured') url.searchParams.delete('sort_by');
      else url.searchParams.set('sort_by', sort);
      history.replaceState(history.state, '', url);
      if (typeof window.acWhenCatalogPainted === 'function') {
        window.acWhenCatalogPainted().then(function () {
          clearSortBusy(seq);
        });
      } else {
        clearSortBusy(seq);
      }
    } finally {
      applyingSort = false;
    }
  }

  document.addEventListener('input', onSortInput, true);

  function boot() {
    revealGrid();
    try {
      applySort(selectedSort());
    } finally {
      revealGrid();
    }
  }

  boot();
  document.addEventListener('ac:product-tags:refit', boot);
})();
